var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExportBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_944_4672",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_944_4672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33329 16.6663C2.87496 16.6663 2.4826 16.5031 2.15621 16.1768C1.82982 15.8504 1.66663 15.458 1.66663 14.9997V4.99967C1.66663 4.54134 1.82982 4.14898 2.15621 3.82259C2.4826 3.4962 2.87496 3.33301 3.33329 3.33301H4.99996V4.99967H3.33329V14.9997H16.6666V4.99967H15V3.33301H16.6666C17.125 3.33301 17.5173 3.4962 17.8437 3.82259C18.1701 4.14898 18.3333 4.54134 18.3333 4.99967V14.9997C18.3333 15.458 18.1701 15.8504 17.8437 16.1768C17.5173 16.5031 17.125 16.6663 16.6666 16.6663H3.33329Z",
    fill: "#068EFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 0.833006L14.1666 4.99967L13 6.16634L10.8333 3.99967L10.8333 10.333L9.16663 10.333L9.16663 3.99967L6.99996 6.16634L5.83329 4.99967L9.99996 0.833006Z",
    fill: "#068EFE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportBlue);
export default __webpack_public_path__ + "static/media/export-blue.0166c43b644f1054dab42e49331b1816.svg";
export { ForwardRef as ReactComponent };